import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Sparkles } from 'lucide-react';

const CTA = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className="relative py-32 bg-black overflow-hidden">
      {/* Background Pattern */}
      <div 
        className="absolute inset-0 opacity-5"
        style={{
          backgroundImage: `
            repeating-linear-gradient(0deg, transparent, transparent 1px, #00FFD1 1px, #00FFD1 2px),
            repeating-linear-gradient(-90deg, transparent, transparent 1px, #00FFD1 1px, #00FFD1 2px)
          `,
          backgroundSize: '60px 60px',
        }}
      />

      <div className="relative max-w-[1400px] mx-auto px-[7.6923%]">
        <div className="relative p-16 bg-gradient-to-br from-[#00FFD1]/10 to-transparent border-2 border-[#00FFD1]/30 overflow-hidden">
          {/* Decorative Elements */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-[#00FFD1]/5 blur-3xl" />
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-[#00FFD1]/5 blur-3xl" />

          <div className="relative text-center space-y-8">
            {/* Icon */}
            <div className="inline-flex items-center justify-center w-20 h-20 bg-[#00FFD1]/20 mb-4">
              <Sparkles className="w-10 h-10 text-[#00FFD1]" />
            </div>

            {/* Headline */}
            <h2 className="display-large text-white max-w-4xl mx-auto">
              Showcase Your Space <span className="text-[#00FFD1]">Like Never Before</span>
            </h2>

            {/* Description */}
            <p className="body-large text-white/85 max-w-2xl mx-auto">
              Give your customers the power to explore your business 24/7 from anywhere in the world. 
              Stand out with immersive 360° virtual tours that drive engagement and conversions.
            </p>

            {/* CTA Button */}
            <div className="pt-8">
              <Button 
                onClick={scrollToContact}
                className="btn-primary text-xl px-12 py-6 h-auto group"
              >
                Book a Virtual Tour
                <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" />
              </Button>
            </div>

            {/* Features List */}
            <div className="flex flex-wrap justify-center gap-8 pt-8 text-white/70">
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 bg-[#00FFD1] rounded-full" />
                <span className="body-small">5-7 Day Delivery</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 bg-[#00FFD1] rounded-full" />
                <span className="body-small">Professional Quality</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 bg-[#00FFD1] rounded-full" />
                <span className="body-small">Easy Integration</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 bg-[#00FFD1] rounded-full" />
                <span className="body-small">Local Service</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
